import React from 'react';

export default (Component, entry, onUpdate) => ((props) => (<Component entry={entry} onUpdate={onUpdate} {...props} />));
